module.exports = __webpack_public_path__ + "static/combined-character-profile-and-worksheet-c28171b4e49c621177d72b5b3c031f70.pdf";